export default __webpack_public_path__ + "static/media/forward_to_inbox_black_24dp.8d2d63fc.svg";